import SectionHeading from "@/components/base/SectionHeading";

const testimonials = [
  {
    name: "阿岚",
    role: "奇幻爱好者",
    avatar: "岚",
    color: "bg-primary-500",
    text: "一直找不到系统的奇幻韩漫清单，韩国漫画大全按题材分得很清楚，跟着专题追了好几部宝藏作品，效率高多了。",
  },
  {
    name: "糖豆",
    role: "校园题材读者",
    avatar: "糖",
    color: "bg-accent-500",
    text: "校园专题的推荐质量很稳，甜文和群像都整理得明明白白，还会持续补充新作，是每周都会逛的网站。",
  },
  {
    name: "晚风",
    role: "古风画风控",
    avatar: "风",
    color: "bg-secondary-500",
    text: "古风专题的画风都很对我的胃口，从宫廷权谋到仙侠都有，简介写得很走心，几乎不会点进失望的作品。",
  },
];

export default function TestimonialSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="读者口碑"
          title="爱看韩漫的人都在这里"
          desc="来自不同题材读者的真实反馈，是我们持续做好韩漫大全分类专题的动力。"
          align="center"
        />
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="flex gap-1 text-accent-500" aria-label="五星好评">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full ${t.color} font-heading font-bold text-background-50`}
                >
                  {t.avatar}
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}